/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Created_ToastInputs */

const en_clients_created_toast = /** @type {(inputs: Clients_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client registered.`)
};

const pt_br2_clients_created_toast = /** @type {(inputs: Clients_Created_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliente cadastrado.`)
};

/**
* | output |
* | --- |
* | "Client registered." |
*
* @param {Clients_Created_ToastInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_created_toast = /** @type {((inputs?: Clients_Created_ToastInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Created_ToastInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_created_toast(inputs)
	return pt_br2_clients_created_toast(inputs)
});